<template>
  <a-card title="内容设置" :bordered="false" :headStyle="{fontSize:'18px'}">
    <a-form-model
      ref="ruleAuditForm"
      :rules="rules"
      :model="ruleAuditForm"
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol"
    >
      <a-form-model-item :label="'成为分销条件'+'\xa0\xa0\xa0\xa0\xa0\xa0'" prop="staffCondition">
        <a-tooltip
          placement="top"
          title="该功能分销店铺有效"
          style="position: absolute;left: -30px;top: 3px"
        >
          <a-icon type="question-circle"/>
        </a-tooltip>
        <a-checkbox-group v-model="ruleAuditForm.staffCondition" @change="setStaffCondition" style="margin-left: 10px">
          <a-checkbox :value="1">购买商品</a-checkbox>
          <a-checkbox disabled :value="2">邀请+扫码</a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="二级分销商注册审核" prop="connectionRegisterIsAutomate">
        <a-radio-group v-model="ruleAuditForm.connectionRegisterIsAutomate">
          <a-radio :value="0">手动审核</a-radio>
          <a-radio :value="1">自动审核</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="默认开分店数量" prop="staffShopNumber">
        <a-input-number :step="1" v-model="ruleAuditForm.staffShopNumber" :min="0" :max="100000"/>
      </a-form-model-item>
      <a-form-model-item label="开店邀请页面宣传语" prop="slogan">
        <a-input
          v-model="ruleAuditForm.slogan"
          style="max-width: 500px"
          placeholder="不超过50个字"
          :maxLength="50"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="开店邀请分享页标题" prop="title">
        <a-input
          v-model="ruleAuditForm.title"
          style="max-width: 500px"
          placeholder="不超过30个字"
          :maxLength="30"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="开店邀请分享页描述" prop="description">
        <a-input
          v-model="ruleAuditForm.description"
          style="max-width: 500px"
          placeholder="不超过45个字"
          :maxLength="45"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="开店邀请页面背景图" required>
        <div class="text-tips">
          图片尺寸750*1020，只能上传jpg/png文件，不更换或删除已上传图片则使用默认
          <a @click="downloadIamge(shareImg, 'shareImg')">下载默认图源文件</a>
        </div>
        <a-upload
          list-type="picture-card"
          class="avatar-uploader"
          :action="actionImageUrl"
          @change="handleChange"
          :before-upload="beforeUploadFile"
          :showUploadList="false"
        >
          <img v-if="ruleAuditForm.inviteBackImg" :src="ruleAuditForm.inviteBackImg" class="avatar"/>
          <a-icon v-else type="plus"/>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="开店注册页面背景图" required>
        <div class="text-tips">
          图片尺寸750*870，只能上传jpg/png文件，不更换或删除已上传图片则使用默认
          <a @click="downloadIamge(registeredImg, 'registeredImg')">下载默认图源文件</a>
        </div>
        <a-upload
          list-type="picture-card"
          class="avatar-uploader"
          :action="actionImageUrl"
          @change="handleChange1"
          :before-upload="beforeUploadFile"
          :showUploadList="false"
        >
          <img v-if="ruleAuditForm.registeredBackImg" :src="ruleAuditForm.registeredBackImg" class="avatar"/>
          <a-icon v-else type="plus"/>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="submitAuditForm('ruleAuditForm')" :loading="submitLoading">保存</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
export default {
  name: 'SocialSetting',
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 4 },
          xl: { span: 5 },
          lg: { span: 5 },
          sm: { span: 7 },
          md: { span: 10 },
          xs: { span: 12 }
        },
        wrapperCol: {
          xxl: { span: 17 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 16 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 14 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 14 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 11 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 11 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 4 },
          xl: { offset: 5 },
          lg: { offset: 5 },
          sm: { offset: 7 },
          md: { offset: 10 },
          xs: { offset: 12 }
        }
      },
      ruleAuditForm: {
        staffCondition: [],
        connectionRegisterIsAutomate: '', //0手动，1自动
        staffShopNumber: 0,
        slogan: '', //邀请页面宣传语
        title: '',
        description: '', //邀请分享页描述
        inviteBackImg: '', //邀请页面背景图
        registeredBackImg: '' //注册页面背景图
      },
      rules: {
        staffCondition: [{ required: true, message: '请选择成为分销条件', trigger: 'change' }],
        connectionRegisterIsAutomate: [{ required: true, message: '请选择二级分销商注册审核', trigger: 'change' }],
        slogan: [{ required: true, message: '请输入开店邀请页面宣传语', trigger: 'blur' }],
        staffShopNumber: [
          { required: true, message: '请输入开店数量', trigger: 'blur' },
          { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正确的入开店数量', trigger: 'blur' }
        ],
        title: [{ required: true, message: '请输入开店邀请分享页标题', trigger: 'blur' }],
        description: [{ required: true, message: '请输入开店邀请分享页描述', trigger: 'blur' }]
      },
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      shareImg: 'https://imgb.woyoubooking.com/common/register_share_code_image_bg.png', //邀请页面背景图
      registeredImg: 'https://imgb.woyoubooking.com/common/register_header_bg.png', //注册页面背景图
      submitLoading: false
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SocialSetting', title: '内容设置' },
      { name: 'SocialRule', title: '佣金规则' }
    ])
    this.getFunctionSettingDetails()
  },
  methods: {
    setStaffCondition(val) {
      this.ruleAuditForm.staffCondition = val
      this.$forceUpdate()
    },
    onChange(dates, dateStrArr) {
      this.queryParams.beginDate = dateStrArr[0]
      this.queryParams.endDate = dateStrArr[1]
    },

    //提交设置信息
    submitAuditForm(formName) {
      this.$refs.ruleAuditForm.validate(valid => {
        if (valid) {
          this.updateFunctionSetting()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //更新功能设置信息
    updateFunctionSetting() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleAuditForm))
      this.submitFormData.inviteBackImg = this.submitFormData.inviteBackImg ? this.submitFormData.inviteBackImg
        : this.shareImg
      this.submitFormData.registeredBackImg = this.submitFormData.registeredBackImg
        ? this.submitFormData.registeredBackImg
        : this.registeredImg
      //成为分销条件-选择购买商品(productPointer)：1 否则为0，后期 productPointer(指定商品 1所有商品)有扩展注意这块逻辑
      this.submitFormData.productPointer = this.submitFormData.staffCondition.length > 1 ? 1 : 0
      this.submitLoading = true
      this.getHttpServices()
        .getUserService()
        .post('merchant/connection/save/function', this.submitFormData)
        .then(res => {
          this.$message.success('保存成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleAuditForm.inviteBackImg = url
      }
    },
    handleChange1(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleAuditForm.registeredBackImg = url
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    beforeUploadFile(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        this.$message.error('请选择正确的图片格式上传!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
        return false
      }
      return true
    },
    //获取功能设置信息
    getFunctionSettingDetails() {
      this.getHttpServices()
        .getUserService()
        .post('merchant/connection/query/function')
        .then(res => {
          this.ruleAuditForm = res
          this.ruleAuditForm.staffCondition = this.ruleAuditForm.staffCondition ? this.ruleAuditForm.staffCondition : [2]
          this.ruleAuditForm.staffShopNumber = this.ruleAuditForm.staffShopNumber ? this.ruleAuditForm.staffShopNumber : '0'
          this.ruleAuditForm.connectionRegisterIsAutomate = res.connectionRegisterIsAutomate != null ? res.connectionRegisterIsAutomate : ''
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    //下载海报方法
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      if (imgsrc) {
        let image = new Image()
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function() {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/jpeg') //得到图片的base64编码数据
          let a = document.createElement('a') // 生成一个a元素
          let event = new MouseEvent('click') // 创建一个单击事件
          a.download = name || 'photo' // 设置图片名称
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
        }
        image.src = imgsrc
      } else {
        this.$message.error('请先点击保存海报后再下载')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.text-tips {
  height: 40px;
  line-height: 40px;
  color: red;
}

.grid-content {
  line-height: 40px;
}

.colorrmb {
  color: #ff6600;
}

.avatar {
  border-radius: 4px;
  width: 100px;
  height: 100px;
}
</style>
